let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dU3Pm")).then(() => parcelRequire('cOdtX'));